import { deckOfCards } from "../../../utils/cardUtils";
import CardExperiment from "./CardExperiment";
// import { Image, Button } from "@chakra-ui/react";
import { useState, useEffect } from "react";
// import "./DeckTwo.css";

import { useSprings } from "react-spring";

const DealDeck = ({ isDealt, setIsDealt, dealDelay, dealer, numPlayers }) => {
  // 6 cards per player - 18 total for 3-player Cutthroat, 24 for every
  // other (4-player) mode.
  const [deck, setDeck] = useState(deckOfCards().splice(0, numPlayers * 6));
  const [containerWidth, setContainerWidth] = useState(window.innerWidth);
  const [containerHeight, setContainerHeight] = useState(window.innerHeight);
  const [selectedCards, setSelectedCards] = useState([]);
  const [playedCards, setPlayedCards] = useState([]);

  console.log("width", containerWidth);
  console.log("height", containerHeight);

  // Mirrors the --card-w breakpoints in Deck.css so dealt cards are the
  // same size as the cards they land on, at any viewport width.
  const cardWidth =
    containerWidth <= 480 ? 40 : containerWidth <= 768 ? 54 : 80;
  const cardHeight =
    containerWidth <= 480 ? 55 : containerWidth <= 768 ? 74 : 111;
  const cardSpacing = cardWidth + 10;
  const margin = Math.max(30, Math.min(100, containerWidth * 0.12));

  // This animation computes its own landing coordinates independent of
  // the CSS that positions each player's name label (Deck.css). Top/bottom
  // sit right up against the viewport edge already - the original
  // corrections (-95*scaleY / +40*scaleY below) leave only ~5-30px of
  // margin before the card runs off-screen, depending on width, so top
  // gets no extra push (no safe room to give) and bottom gets a small one
  // sized to fit inside that margin. desktop/tablet are untouched since
  // this is 0 above 480px.
  const mobileNameBufferBottom = containerWidth <= 480 ? 15 : 0;

  // Mobile only: match the CSS resting position for .player2Game/
  // .player4Game (Deck.css) exactly, instead of the independently-tuned
  // `margin` inset used below for tablet/desktop. That resting position is
  // just .playerHand's 5px padding against the container's left:0/right:0
  // - not derived from `margin` at all - so a margin-based landing spot
  // never actually matched where the cards end up once dealDeck flips off,
  // causing a jump. CardExperiment rotates each card around its own center
  // (not the corner-anchored transform Deck.css uses for the container),
  // so hitting that same screen position takes this math instead of a
  // plain edge offset.
  const mobileSideEdgeGap = 5;

  const calculateCardPositions = (width, height, remainingCards) => {
    return [
      {
        x: width / 2 - cardWidth * 1.5,
        y: height - cardHeight - margin,
        position: "bottom",
      },
      {
        x:
          containerWidth <= 480
            ? mobileSideEdgeGap + cardHeight / 2 - cardWidth / 2
            : margin,
        y: height / 2 - cardHeight * 0.67,
        position: "left",
      },
      { x: width / 2 - cardWidth * 0.93, y: margin, position: "top" },
      {
        x:
          containerWidth <= 480
            ? width - mobileSideEdgeGap - cardHeight / 2 - cardWidth / 2
            : width - margin,
        y: height / 2 - cardHeight * 0.67,
        position: "right",
      },
    ];
  };

  useEffect(() => {
    if (selectedCards.length === 4) {
      setTimeout(() => {
        setPlayedCards((prevPlayedCards) => [
          ...prevPlayedCards,
          ...selectedCards,
        ]);
        setSelectedCards([]);
      }, 2000);
    }
  }, [selectedCards]);

  const handleCardClick = (index) => {
    setSelectedCards((prevSelectedCards) =>
      prevSelectedCards.includes(index)
        ? prevSelectedCards.filter((i) => i !== index)
        : [...prevSelectedCards, index]
    );

    // Add the played card index to playedCards state
  };
  const [playerPositions, setPlayerPositions] = useState(
    calculateCardPositions(containerWidth, containerHeight)
  );

  console.log(deck);

  const handleResize = () => {
    setContainerWidth(window.innerWidth);
    setContainerHeight(window.innerHeight);
  };

  useEffect(() => {
    // Update player positions when the container size changes
    const newPlayerPositions = calculateCardPositions(
      containerWidth,
      containerHeight
    );
    setPlayerPositions(newPlayerPositions);

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [containerWidth, containerHeight]);

  const springs = useSprings(
    deck.length,
    deck.map((card, index) => {
      // calculateCardPositions returns [bottom, left, top, right], which is
      // the same P1/P2/P3/P4 order playersInfo and dealCards use - modding
      // by numPlayers instead of a hardcoded 4 means a 3-player deal only
      // ever cycles through bottom/left/top (P1-P3), so the animation never
      // tries to deal into the right (P4) position at all.
      const playerIndex = (Math.floor(index / 3) + dealer) % numPlayers;
      // Cards are dealt in two rounds of 3-per-player, so round 2 starts
      // at numPlayers*3 (e.g. 9 for 3 players, 12 for 4) - not a hardcoded
      // 12. With the hardcoded value, 3-player round-2 groups at index
      // 9-11 were still counted as round 1, reusing slots 0-2 instead of
      // 3-5 and landing on top of that player's round-1 cards.
      const cardIndex = (index % 3) + Math.floor(index / (numPlayers * 3)) * 3;
      const { x, y, position } = playerPositions[playerIndex];

      //   const dealDelay = 200; // Change this to adjust the delay between dealing cards to players
      const playedCardCount = selectedCards.filter(
        (cardIndex) => Math.floor(cardIndex / 3) === playerIndex
      ).length;
      const remainingCardCount = 6 - playedCardCount;

      const rotate = position === "left" ? 90 : position === "right" ? -90 : 0;
      const playRotate = position === "left" || position === "right" ? 45 : 0;

      // These landing-position corrections were tuned for the desktop
      // 80x111 card size - scale them proportionally so smaller/larger
      // --card-w breakpoints still land in the right spot.
      const scaleX = cardWidth / 80;
      const scaleY = cardHeight / 111;

      const bottomRowStartX =
        containerWidth / 2 - ((remainingCardCount - 1) * cardSpacing) / 2;

      const adjustedCardIndex = selectedCards.reduce(
        (count, playedIndex) =>
          playedIndex < index && Math.floor(playedIndex / 3) === playerIndex
            ? count + 1
            : count,
        0
      );

      return {
        from: {
          x: containerWidth / 2 - cardWidth / 2,
          y: containerHeight / 2 - cardHeight / 2,
          rotate: 0,
        },
        to: selectedCards.includes(index)
          ? {
              x:
                containerWidth / 2 -
                cardWidth / 2 +
                (position === "left" ? -120 : position === "right" ? 120 : 0),
              y:
                containerHeight / 2 -
                cardHeight / 2 +
                (position === "top" ? -120 : position === "bottom" ? 120 : 0),
              rotate: playRotate,
            }
          : isDealt
          ? {
              x:
                position === "left" || position === "right"
                  ? containerWidth <= 480
                    ? x
                    : position === "right"
                      ? x
                      : x - cardWidth
                  : bottomRowStartX +
                    (cardIndex - adjustedCardIndex) * cardSpacing -
                    40 * scaleX,
              y:
                position === "top" || position === "bottom"
                  ? position === "top"
                    ? y - 95 * scaleY
                    : y + 40 * scaleY + mobileNameBufferBottom
                  : y + cardIndex * cardSpacing - 200 * scaleY,
              rotate: rotate,
            }
          : {
              x: containerWidth / 2 - cardWidth / 2,
              y: containerHeight / 2 - cardHeight / 2,
              rotate: 0,
            },
        config: { tension: 230, friction: 26 },
        delay: index * dealDelay,
      };
    })
  );

  return (
    <div>
      {springs.map((props, index) => {
        if (playedCards.includes(index)) return null;
        const cards = deck[index];

        return (
          <CardExperiment
            key={index}
            card={cards?.details?.card}
            x={props.x}
            y={props.y}
            rotate={props.rotate}
            width={cardWidth}
          />
        );
      })}
    </div>
  );
};
export default DealDeck;
